<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="900px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="ApproveAndSignPrint">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
      <div
        ref="HTMLApproveAndSignPrint"
        id="HTMLApproveAndSignPrint"
        style="padding-top: 30px"
      >
        <div
          style="
            text-align: center;
            font-size: 30px;
            padding: 0 0 20px;
            font-family: fangzheng_GBK;
            font-weight: 500;
          "
        >
          青岛路桥建设集团有限公司
        </div>
        <div
          style="
            text-align: center;
            font-size: 30px;
            font-family: fangzheng_GBK;
            font-weight: 500;
            margin-bottom: 20px;
          "
        >
        {{ formData.signTableName||'合同审核审批表' }}
        </div>
        <div style="font-size: 16px">
          <div style="display: inline-block; width: 100px; text-align: right">
            经办部门:
          </div>
          <div
            contenteditable="true"
            style="display: inline-block; width: calc(100% - 240px)"
          >
            {{ formData.handleDeptName }}
          </div>
          <div
            contenteditable="true"
            style="display: inline-block; text-align: right"
          >
            {{ formData.signDate }}
          </div>
        </div>
        <div
          style="border: 1px solid rgb(0, 0, 0); margin: 4px 0; font-size: 16px"
        >
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              合同名称
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.contractName }}
            </div>
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              合同编号
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
            <!-- {{ formData.contractSerialNumber.trim() }} -->
              {{ formData.contractSerialNumber.substring(0,40) }}
              {{ formData.contractSerialNumber.substring(40) }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              我方单位
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.partyA }}
            </div>
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              相对方单位
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.partyB }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              合同项目
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.projectName }}
            </div>
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              合同金额（元）
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.contractAmount }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              <span style="padding: 0 12px"> 合同签订依据 </span>
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.signAccording }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              所用印章
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.sealType }}
            </div>
          </div>
          <div
            style="
              display: flex;
              min-height: 500px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              <span style="padding: 0 10px"
                >合同说明 （合同目的、双方主要权利义务等）</span
              >
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px;"
            >
              {{ formData.agreeOn }}
            </div>
          </div>
        </div>
        <div
          style="
            border: 1px solid rgb(0, 0, 0);
            margin: 4px 0;
            font-size: 16px;
            page-break-before: always;
            display: flex;
            flex-direction: row;
            align-items: center;
          "
        >
          <div style="width: 100px;text-align: center;">
            路桥集团
          </div>
          <div
            contenteditable="true"
            style="flex: 1;border-left: 1px solid rgb(0, 0, 0);"
          >
            <div
              style="
                border-bottom: 1px solid rgb(0, 0, 0);                
                display: flex;
                min-height: 68px;
              "
            >
              <div
                style="
                  width: 130px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                经办部门负责人： 
              </div>
              <div
                v-if="formData.handleChargeUserSign"
                style="
                 flex: 1;
                  padding: 4px;
                  display: flex;
                  align-items: flex-end;
                  /* flex-direction: column; */
                  margin: 2px 10px 0 0;
                "
              >
                <img
                  :src="formData.handleChargeUserSign"
                  width="100px"
                  height="48px"
                />
              </div>
              <div
              v-else
                contenteditable="true"
                style="
                  flex: 1;
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                {{ formData.handleChargeUserName }}
              </div>
              <div
                style="
                  width: 100px;
                  border-left: 1px solid rgb(0, 0, 0);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                经办人：
              </div>
              <div
                v-if="formData.handleUserSign"
                style="
                 flex: 1;
                  padding: 4px;
                  display: flex;
                  align-items: flex-end;
                  /* flex-direction: column; */
                  margin: 2px 10px 0 0;
                "
              >
                <img
                  :src="formData.handleUserSign"
                  width="100px"
                  height="48px"
                />
              </div>
              <div
              v-else
                contenteditable="true"
                style="
                  flex: 1;
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                {{ formData.handleUserName }}
              </div>
            </div>
            <div  v-for="(item, index) in formData.filterApproveInfoList"
              :key="index">
            <div
              style="
                border-bottom: 1px solid rgb(0, 0, 0);
                display: flex;
                min-height: 120px;
              "
              :style="{
                borderColor:
                  index == formData.filterApproveInfoList.length - 1
                    ? 'rgb(0,0,0,0)'
                    : 'rgb(0,0,0)',
              }"
            >
              <div
                style="
                  width: 100px;
                  border-right: 1px solid rgb(0, 0, 0);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                "
              >
              <span style="padding: 4px;">{{ item.deptKeyName }}</span>                
              </div>
              <div
                contenteditable="true"
                style="
                  flex: 1;
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                {{ item.opinion }}
              </div>
              <div
                v-if="item.approveUserNameSignUrl"
                style="
                  display: flex;
                  align-items: flex-end;
                  justify-content: flex-end;
                  /* flex-direction: column; */
                  margin: 2px 10px 6px 0;
                "
              >
                <img
                  :src="item.approveUserNameSignUrl"
                  width="100px"
                  height="48px"
                  style="padding-bottom: 12px;"
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日
              </div>
              <div
                v-else
                style="
                  display: flex;
                  align-items: flex-end;
                  justify-content: flex-end;
                  /* flex-direction: column; */
                  padding: 2px 10px 6px 0;
                "
              >
                <span style="padding-bottom: 12px;">{{ item.approveUserName }}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日
              </div>
            </div>
          </div>
          </div>
        </div>
        <div style="margin-left: 20px;">1.按照合同管理办法规定的管控权限履行相应的审核审批程序。2.表格双面打印。</div>
        <div height="20px">&nbsp;</div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="ApproveAndSignPrintContent"
          class="mainHtml"
          id="printApproveAndSignPrintContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "ApproveAndSignPrint",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
  },
  data() {
    return {
      approveProcessList: [],
      ApproveAndSignPrintContent: null,
    };
  },
  computed: {
    formData() {
      const filterApproveInfoList = this.printData.approveInfoList.filter(
        (i) => i.isPrint
      );
      return {
        ...this.printData,
        filterApproveInfoList,
      };
    },
  },

  mounted() {
    // this.ApproveAndSignPrintContent =
    //   this.$refs.HTMLApproveAndSignPrint.innerHTML;
    // this.ApproveAndSignPrintContent = document.getElementById(
    //   "HTMLApproveAndSignPrint"
    // ).innerHTML;
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "ApproveAndSignPrintContent",
        this.$refs.HTMLApproveAndSignPrint.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printApproveAndSignPrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
  },
};
</script>
<style lang="scss">
#HTMLApproveAndSignPrint {
  box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
